/* ContactsView holds all contacts-related stuff */
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import AccessMode from '../tinode/access-mode'

import ContactList from '../widgets/contact-list.jsx';

import { updateFavicon } from '../lib/utils.js';
import { Tinode } from '../tinode/tinode.js';
import { Topic } from '../tinode/topic.js';
import { IconContact404, IconBinoculars404, IconPerson404 } from '../icons/svg';
import Helpers from '../lib/helpers';

const messages = defineMessages({
  archived_contacts_title: {
    id: "archived_contacts",
    defaultMessage: "Archived contacts ({count})",
    description: "Label for archived chats"
  }
});

export default class ContactsView extends React.Component {
  constructor(props) {
    super(props);

    this.handleAction = this.handleAction.bind(this);
    this.getIconEmpty = this.getIconEmpty.bind(this);

    this.state = ContactsView.deriveStateFromProps(props);
  }

  static deriveStateFromProps(props) {
    const contacts = [];
    let unreadThreads = 0;
    let archivedCount = 0;
    if (props.searchResults && props.searchResults.length > 0 || props.search !== Tinode.DEL_CHAR) {
      props.searchResults.forEach((c) => {
        switch (props.optionSearch) {
          case Tinode.OPTIONS_SEARCH.CONTACT:
            if (!Topic.isGroupTopicName(c.name)) {
              // c.acs = new AccessMode({
              //   given: 'JRWPASDO',
              //   want: 'JRWPASDO',
              //   mode: 'JRWPASDO',
              // })
              contacts.push(c);
            }
            break;
          case Tinode.OPTIONS_SEARCH.GROUP:
            if (Topic.isGroupTopicName(c.name)) {
              // c.acs = new AccessMode({
              //   given: 'JRWPASDO',
              //   want: 'JRWPASDO',
              //   mode: 'JRWPASDO',
              // })
              contacts.push(c);
            }
            break;
          default:
            // c.acs = new AccessMode({
            //   given: 'JRWPASDO',
            //   want: 'JRWPASDO',
            //   mode: 'JRWPASDO',
            // })
            contacts.push(c);
            break;
        }
      })
    } else {
      // switch (props.optionSearch) {
      //   case Tinode.OPTIONS_SEARCH.CONTACT:
      //     props.chatList.map((c) => {
      //       if (!c.isGroupType()) {
      //         contacts.push(c);
      //         unreadThreads += c.unread > 0 ? 1 : 0;
      //       }
      //     });
      //     break;
      //   case Tinode.OPTIONS_SEARCH.GROUP:
      //     props.chatList.map((c) => {
      //       if (c.isGroupType()) {
      //         contacts.push(c);
      //         unreadThreads += c.unread > 0 ? 1 : 0;
      //       }
      //     });
      //     break;
      //   default:
          props.chatList.map((c) => {
            // const blocked = c.acs && !c.acs.isJoiner();
            // // Show only blocked contacts only when props.blocked == true.
            // if (blocked && props.blocked) {
            //   contacts.push(c);
            // }
            // if (blocked || props.blocked) {
            //   return;
            // }

            // if (c.private && c.private.arch) {
            //   if (props.archive) {
            //     contacts.push(c);
            //   } else {
            //     archivedCount++;
            //   }
            // } else if (!props.archive) {
            //   contacts.push(c);
            //   unreadThreads += c.unread > 0 ? 1 : 0;
            // }
            if (!(c.private && c.private.arch) && !props.archive) {
              unreadThreads += c.unread > 0 ? 1 : 0;
            }
            if (c.latestMessage && c.latestMessage()) {
              contacts.push(c);
            }
          });
          // break;
      // }
    }

    const isSearching = props.search && typeof props.search !== 'undefined' && props.search !== Tinode.DEL_CHAR

    contacts.sort((a, b) => {
      if (b.isPin === true || a.isPin === true) {
        if (a.isPin && !b.isPin) {
          return -1
        } else if (!a.isPin && b.isPin) {
          return 1
        }
      }
      if (isSearching) {
        return Helpers.sortByPrimaryName(a, b);
      }
      return (b.touched || 0) - (a.touched || 0);
    });

    if (archivedCount > 0) {
      contacts.push({
        action: 'archive',
        title: messages.archived_contacts_title,
        values: { count: archivedCount }
      });
    }

    return {
      contactList: contacts,
      unreadThreads: unreadThreads
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.chatList != this.props.chatList ||
      prevProps.archive != this.props.archive ||
      prevProps.blocked != this.props.blocked ||
      prevProps.optionSearch != this.props.optionSearch) {
      const newState = ContactsView.deriveStateFromProps(this.props);
      this.setState(newState);
      if (newState.unreadThreads != prevState.unreadThreads) {
        updateFavicon(newState.unreadThreads);
      }
    }
  }

  handleAction(action_ignored) {
    this.props.onShowArchive();
  }

  getIconEmpty() {
    switch (this.props.optionSearch) {
      case Tinode.OPTIONS_SEARCH.CONTACT:
        return <IconContact404 />
      case Tinode.OPTIONS_SEARCH.MESSAGE:
        return <IconBinoculars404 />
      case Tinode.OPTIONS_SEARCH.GROUP:
        return <IconPerson404 />
      default:
        return undefined;
    }
  }

  render() {
    return (
      <FormattedMessage id="contacts_not_found"
        defaultMessage="You have no chats<br />¯∖_(ツ)_/¯"
        description="HTML message shown in ContactList when no contacts are found">
        {
          (no_contacts) => <ContactList
            showLastMsgTime={true}
            tinode={this.props.tinode}
            connected={this.props.connected}
            contacts={this.state.contactList}
            emptyListMessage={no_contacts}
            topicSelected={this.props.topicSelected}
            myUserId={this.props.myUserId}
            showOnline={true}
            showUnread={true}
            isHideTopic={this.props.isHideTopic}
            onTopicSelected={this.props.searchResults && this.props.searchResults.length > 0 ?
              this.props.handleSearchResultSelected : this.props.onTopicSelected}
            showContextMenu={this.props.showContextMenu}
            onAction={this.handleAction}
            iconEmpty={this.getIconEmpty()}
            isShowTyping={this.props.isShowTyping}
            isShowPin={this.props.isShowPin}
          />
        }
      </FormattedMessage>
    );
  }
};
